import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';
@Pipe({ name: 'PaymentType' })
export class PaymentStatusPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: any): any {
    let paymentType = '';
    if (value !== undefined && value !== null && value !== '') {
      switch (Number(value)) {
        case 30: // Debit Card
          paymentType = 'Common_lblDebitCard';
          break;
        case 10: // Store
          paymentType = 'Common_lblPayStore';
          break;
        default:
          break;
      }
      return paymentType != '' ? this.translate.instant(paymentType) : '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/PaymentType.ts